<template>
    <div class="list_row">
        <span class="label_title">
            <strong>
                {{ value.label }}
            </strong>
        </span>

        <span class="label_content">
            <input type="checkbox" :checked="value.answer" disabled />
        </span>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: true
        }
    }
};
</script>
